export const UPLOAD_PDF = gql`
    mutation UploadPdf($buffer: String!) {
        uploadPdf(buffer: $buffer) {
            compressedBuffer
        }
    }
`;
